import { render, staticRenderFns } from "./Joke.vue?vue&type=template&id=37900a55&"
import script from "./Joke.vue?vue&type=script&lang=js&"
export * from "./Joke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports